import { render, staticRenderFns } from "./MobileNumberInput.vue?vue&type=template&id=85826508&scoped=true&"
import script from "./MobileNumberInput.vue?vue&type=script&lang=js&"
export * from "./MobileNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85826508",
  null
  
)

export default component.exports